module.exports = __webpack_public_path__ + "static/HERO-2a42adb12f68aa52398417eeb2e3acff.png";